import { SecurityContext, DOCUMENT } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { AppsService } from "app/commons/services/applications.service";
import { LanguagesService } from "app/commons/services/languages.service";
import { StorageService } from "app/commons/services/storageService.service";
import { currentLanguageToken, currentTenantToken, languagesToken, tenantsToken } from "app/root/app.root.resolvers";
import { IAirline } from "app/types/airline";
import { ILanguage } from "app/types/language";

export const deepLinkState: Ng2StateDeclaration = {
  name: "deepLink",
  parent: "ng2Root",
  url: "/deeplink?{app}&{tenant}&{language}&{path}",
  params: {
    app: {
      type: "string",
      value: null
    },
    tenant: {
      type: "string",
      value: null
    },
    language: {
      type: "string",
      value: null
    },
    path: {
      type: "string",
      value: null
    }
  },
  redirectTo: async (transition) => {
    const $state = transition.router.stateService;
    const params = transition.params();
    if (!params.app) return $state.target("openairdashboard");
    const injector = transition.injector();
    const app = injector.get<AppsService>(AppsService).getApplicationSync(params.app);
    if (!app) return $state.target("openairdashboard");
    const currentTenant = await injector.getAsync<IAirline>(currentTenantToken);
    const currentLanguage = await injector.getAsync<ILanguage>(currentLanguageToken);
    const tenantParam = params.tenant || currentTenant.code;
    const languageParam = params.language || currentLanguage.language;
    if (currentTenant.code == tenantParam && currentLanguage.language != languageParam) {
      const languages = await injector.getAsync<ILanguage[]>(languagesToken);
      const foundLanguage = languages.find(item => item.language == languageParam);
      if (foundLanguage)
        injector.get<StorageService>(StorageService).set.currentLanguage(foundLanguage);
    }
    else if (currentTenant.code != tenantParam) {
      const tenants = await injector.getAsync<IAirline[]>(tenantsToken);
      const foundTenant = tenants.find(item => item.code == tenantParam);
      if (foundTenant) {
        const storage = injector.get<StorageService>(StorageService);
        const languages = await injector.get<LanguagesService>(LanguagesService).getAirlineLanguages(foundTenant.id);
        const foundLanguage = languages.find(item => item.language == languageParam);
        if (foundLanguage) storage.set.currentLanguage(foundLanguage);
        storage.set.currentAirline(foundTenant);
      }
    }
    const sanitizer = injector.get<DomSanitizer>(DomSanitizer);
    const sanitizedPath = sanitizer.sanitize(SecurityContext.URL, params.path ? `${app.link}/${params.path}` : app.link);
    const window = injector.get<Document>(DOCUMENT).defaultView;
    window.location.href = sanitizedPath;
  }
}
